/* eslint-disable react/no-array-index-key */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import handleKeyPress from '../../../../common/handleKeyPress';

import CustomTooltip from '../../../../componentLibrary/CustomTooltip';
import * as Styled from './styles';

const Button = ({ icon, text, onClick, dataTestId, tooltipText, cursor }) => {
    const [hovering, setHovering] = useState(false);
    const fill = hovering ? '#1E77BD' : '#727273';
    return (
        <Styled.ButtonWrapper
            data-tip
            data-for={dataTestId}
            data-test-id={dataTestId}
            hovering={hovering}
            cursor={cursor}
            onMouseEnter={() => setHovering(true)}
            onMouseLeave={() => setHovering(false)}
            onClick={onClick}
            role="button"
            aria-label={`Add ${text}`}
            tabIndex={0}
            onKeyPress={(e) => handleKeyPress(e, onClick)}
        >
            <Styled.IconWrapper>
                <img aria-hidden src={icon} alt={text} fill={fill} />
            </Styled.IconWrapper>
            <Styled.ButtonText>{text}</Styled.ButtonText>
            {tooltipText && <CustomTooltip dataRef={dataTestId} effect="float" text={tooltipText} />}
        </Styled.ButtonWrapper>
    );
};

const buttonType = {
    icon: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    dataTestId: PropTypes.string.isRequired,
    tooltipText: PropTypes.string,
    cursor: PropTypes.string,
};

Button.defaultProps = {
    tooltipText: '',
    cursor: 'pointer',
};

Button.propTypes = buttonType;

const ParagraphButtonMenu = ({ buttons, label }) => {
    const [menuOpen, setMenuOpen] = useState(true);

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    return (
        <div role="menuitem" aria-expanded={menuOpen}>
            <Styled.Label
                onClick={toggleMenu}
                role="button"
                aria-label={`${menuOpen ? 'Collapse' : 'Expand'} ${label} menu`}
                tabIndex={0}
                onKeyPress={(e) => handleKeyPress(e, toggleMenu)}
            >
                {label.toUpperCase()}
                <i className="material-icons" aria-hidden style={{ fontSize: 18, marginTop: 2 }}>
                    {`arrow_drop_${menuOpen ? 'up' : 'down'}`}
                </i>
            </Styled.Label>
            {menuOpen && buttons.map((props, i) => <Button key={`pbkey-${i}`} {...props} />)}
        </div>
    );
};

ParagraphButtonMenu.propTypes = {
    buttons: PropTypes.arrayOf(PropTypes.shape(buttonType)).isRequired,
    label: PropTypes.string.isRequired,
};

export default ParagraphButtonMenu;
